import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import SignIn from '../../components/user-flow/SignIn';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import SignUp from '../../components/user-flow/SignUp';
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import PasswordReset from '../../components/user-flow/PasswordReset';
import useToken from '../../hooks/useToken';
import PendingRequest from '../../components/user-flow/PendingRequest';
import CompanyWrapper from '../../components/user-flow/CompanyWrapper';
import VerifyEmailViaLink from '../../components/user-flow/styled/VerifyEmailViaLink';

type AuthType =
  | 'sign-in'
  | 'sign-up'
  | 'reset'
  | 'pending'
  | 'rejected'
  | 'organization'
  | 'change-email'
  | 'verify'
  | 'verify-link'
  | 'invite';

const UserFlow: React.FC = () => {
  const { type } = useParams<{ type: AuthType }>();
  const navigate = useNavigate();
  const [element, setElement] = useState<JSX.Element>(<SignIn />);

  const { decodedToken } = useToken();
  const userState = useSelector((state: RootState) => state.user);

  const handleOrganizationNavigation = () => {
    const signupToken = userState.signupToken || localStorage.getItem('signupToken');
    if (signupToken) {
      setElement(<CompanyWrapper />);
    } else {
      navigate('/');
    }
  };

  const renderElementType = (type: AuthType) => {
    switch (type) {
      case 'sign-in':
        setElement(<SignIn />);
        break;
      case 'sign-up':
        setElement(<SignUp />);
        break;
      case 'reset':
        setElement(<PasswordReset />);
        break;
      case 'pending':
        setElement(<PendingRequest />);
        break;
      case 'invite':
        setElement(<SignUp />);
        break;
      case 'organization':
        handleOrganizationNavigation();
        break;
      case 'verify-link':
        setElement(<VerifyEmailViaLink />);
        break;
      default:
        setElement(<SignIn />);
        break;
    }
  };

  useEffect(() => {
    if (type) {
      renderElementType(type);
    }
  }, [type]);

  if (decodedToken && type !== 'reset') {
    return <Navigate to="/" replace />;
  }

  return (
    <Box>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <Grid item xs={12} sm={8} md={8} component={Paper} elevation={0} square>
          {element}
        </Grid>
        <Grid
          item
          xs={false}
          sm={4}
          md={4}
          sx={{
            backgroundImage: `url('/LoginPage.png')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            p: (theme) => theme.spacing(8),
          }}
        />
      </Grid>
    </Box>
  );
};

export default UserFlow;
